<template>
    <div>
      <JournalDoor/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import JournalDoor from './components/JournalDoor';

export default {
  name: 'DoorOpening',
  components: { JournalDoor },
  props: ['id'],
  data () {
    return {};
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
    }),
  },
};
</script>
